import { createSlice, Reducer, Slice } from "@reduxjs/toolkit";

import { PromotionPlanningDropdownModel, PromotionPlanningSelectedSlicerModel } from "../../models/TradeAndPromoPlanning/PromotionPlanningSlicer.model";
import PromotionPlanningTabSlice from "../../models/Redux/PromotionPlanningTabSlice.model";
import { getDefaultSlicersForForecastEntryApp } from "../../shared/functions";
import { PROMOTION_PLANNING_TAB_ID } from "../../shared/constants";

const defaultSlicers: PromotionPlanningSelectedSlicerModel = getDefaultSlicersForForecastEntryApp(PROMOTION_PLANNING_TAB_ID);

const initialState: PromotionPlanningTabSlice = {
    tempSelectedSlicers: defaultSlicers,
    selectedSlicers: defaultSlicers,
    slicers: {
        sku: [],
        years: []
    }
};

const promotionPlanningTabSlice: Slice = createSlice({
    name: "promotionPlanning",
    initialState,
    reducers: {
        setSlicers: (state: PromotionPlanningTabSlice, action: { payload: PromotionPlanningDropdownModel }) => {
            state.slicers = action.payload;
        },
        setTempSlicers: (state, action: { payload: PromotionPlanningSelectedSlicerModel }) => {
            state.tempSelectedSlicers = action.payload;
        },
        setSelectedSlicers: (state, action: { payload: PromotionPlanningSelectedSlicerModel }) => {
            state.selectedSlicers = action.payload;
        },
        resetSelectedSlicers: (state, action) => {
            state.tempSelectedSlicers = structuredClone(defaultSlicers);
            state.selectedSlicers = structuredClone(defaultSlicers);
        }
    }
});

export const promotionPlanningTabActions = promotionPlanningTabSlice.actions;

export default promotionPlanningTabSlice.reducer as Reducer<PromotionPlanningTabSlice>;
